import React, { useState } from "react"
import { Modal } from "react-bootstrap"
import { useSelector, useDispatch } from "react-redux"
import { Input } from "../forms/Input"
import { setSuccess } from "../../redux/flashMessages"
import { setUser } from "../../redux/authenticationSlice"
import { ModalFooterLoader } from "./ModalFooterLoader"
import { useAxios } from "../../hooks/useAxios"
export const UpdateUserDetails = ({ show, hide }) => {
  const api = useAxios()
  const authenticatedUser = useSelector((state) => state.authentication.user)
  const dispatch = useDispatch()
  const [email, setEmail] = useState(() => authenticatedUser?.email)
  const [phone, setPhone] = useState(() => authenticatedUser?.phone)
  const [password, setPassword] = useState()
  const [passwordConfirmation, setPasswordConfirmation] = useState()
  const [updatePassword, setUpdatePassword] = useState(false)
  const [validationErrors, setValidationErrors] = useState()
  const [loading, setLoading] = useState(false)

  const updateContact = async () => {
    setValidationErrors()
    setLoading(true)
    const data = {
      id: authenticatedUser?.id,
      email,
      phone,
      password,
      password_confirmation: passwordConfirmation,
      update_password: updatePassword,
    }
    console.log(data)
    console.log(`${process.env.REACT_APP_BACKEND_URL}user/update`)
    try {
      const response = await api.post(`${process.env.REACT_APP_BACKEND_URL}user/update`, data)
      dispatch(setSuccess("Your details has been updated!"))
      dispatch(setUser(response.data))
      setUpdatePassword(false)
      hide()
    } catch (ex) {
      setValidationErrors(ex.response.data.errors)
    } finally {
      setLoading(false)
    }
  }

  return (
    <Modal
      show={show}
      onHide={() => {
        setUpdatePassword(false)
        hide()
      }}
      size="lg">
      <Modal.Header closeButton>Update Your Details</Modal.Header>
      <Modal.Body>
        <Input
          error={validationErrors?.email}
          type="email"
          label={`Email`}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <Input
          error={validationErrors?.phone}
          type="text"
          label={`Phone Number`}
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
        />
        <div className="form-check form-switch mt-3">
          <input
            className="form-check-input"
            type="checkbox"
            id="flexSwitchCheckDefault"
            onChange={() => setUpdatePassword(!updatePassword)}
            value={updatePassword}
          />
          <label className="form-check-label" htmlFor="flexSwitchCheckDefault">
            Update Password
          </label>
        </div>
        {updatePassword && (
          <>
            <Input
              error={validationErrors?.password}
              type="password"
              label={`password`}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <Input
              error={validationErrors?.password_confirmation}
              type="password"
              label={`Password Confirmation`}
              value={passwordConfirmation}
              onChange={(e) => setPasswordConfirmation(e.target.value)}
            />
          </>
        )}
      </Modal.Body>
      <Modal.Footer className="d-flex align-items-center justify-content-between">
        <div>{loading && <ModalFooterLoader />}</div>
        <div className="btn-group">
          <button className="btn btn-secondary" onClick={hide}>
            Cancel
          </button>
          <button className="btn btn-primary float-end" onClick={updateContact}>
            <i className="fa fa-refresh mx-1"></i> <span className="mx-1">Update</span>
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  )
}
